export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";